const CalendarIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 22C4.45 22 3.97917 21.8041 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V5.99995C3 5.44995 3.19583 4.97912 3.5875 4.58745C3.97917 4.19579 4.45 3.99995 5 3.99995H6V1.99995H8V3.99995H16V1.99995H18V3.99995H19C19.55 3.99995 20.0208 4.19579 20.4125 4.58745C20.8042 4.97912 21 5.44995 21 5.99995V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8041 19.55 22 19 22H5ZM5 20H19V9.99995H5V20ZM5 7.99995H19V5.99995H5V7.99995Z" fill="currentColor"/>
  </svg>
)

export default CalendarIcon
